export type AdminFeature = {
  id: string
  key: string
  name: string
  description: string | null
  sort_order: number
  disabled: boolean
  permission_count: number
  created_at: string
  updated_at: string
}

export type TenantTypeFeatureMatrixRow = {
  tenant_type: string
  feature_id: string
  feature_key: string
  feature_name: string
  enabled: boolean
}

export type TenantCustomFeatureRow = {
  feature_id: string
  feature_key: string
  feature_name: string
  enabled: boolean
}

export type TenantFeatureOverrideRow = {
  feature_key: string
  feature_name: string
  in_plan: boolean
  override_enabled: boolean
  has_override: boolean
}

export type TenantEffectiveFeatureRow = {
  feature_key: string
  feature_name: string
  source: 'type' | 'custom' | 'type+custom' | 'plan' | 'override'
}

export type FeatureFormValues = {
  key: string
  name: string
  description: string
  sort_order: number
  disabled: boolean
}

export const emptyFeatureFormValues: FeatureFormValues = {
  key: '',
  name: '',
  description: '',
  sort_order: 0,
  disabled: false
}

export type FeaturePermissionRow = {
  feature_id: string
  feature_key: string
  feature_name: string
  feature_description: string | null
  feature_sort_order: number
  feature_disabled: boolean
  permission_id: string | null
  permission_name: string | null
  permission_description: string | null
  permission_disabled: boolean | null
}

export type AdminPermission = {
  id: string
  name: string
  description: string | null
  disabled: boolean
  feature_id: string
  feature_key: string
}

export type PermissionFormValues = {
  name: string
  description: string
  disabled: boolean
}

export const emptyPermissionFormValues: PermissionFormValues = {
  name: '',
  description: '',
  disabled: false
}

export type SystemRoleRow = {
  id: string
  name: string
  description: string | null
  actor_kind: string
  user_type: string | null
  account_owner: boolean
  permission_count: number
}

export type SystemRoleDetail = {
  id: string
  name: string
  description: string | null
  actor_kind: string
  user_type: string | null
  account_owner: boolean
  permission_ids: string[]
}

export type IcpAssignablePermission = {
  id: string
  name: string
  description: string | null
  feature_id: string | null
  feature_key: string
  feature_name: string | null
  feature_sort_order: number | null
}
